const directoryBuilder = {
    calculateDirectory: (id: number) => {
        //@ts-ignore
        let fiftyK: number = (Math.floor(id / 50000))
        let lowEndFirst: string = (50000 * fiftyK).toString()
        let highEndFirst: string = ((50000 * fiftyK) + 49999).toString()
        //@ts-ignore
        let tenK: number = (Math.floor(id / 10000))
        let lowEndSecond: string = (10000 * tenK).toString()
        let highEndSecond: string = ((10000 * tenK) + 9999).toString()
        //@ts-ignore
        let directory = `${lowEndFirst}-${highEndFirst}/${lowEndSecond}-${highEndSecond}`
        return directory
    }
}
export default directoryBuilder